// ============================================================
// BilanCommande — l'affaire a-t-elle gagné de l'argent ? 6 octobre 2026.
// ------------------------------------------------------------
// Les minutes disent où l'atelier s'écarte du devis ; elles ne disent pas
// si la COMMANDE est gagnante. Facturé contre ce qu'il aurait fallu
// facturer au temps réel, sur toute la quantité, mise en route comprise —
// calculé côté serveur par la fonction de prix du devis (`bilanCommande`).
// Usinage seulement : matière, traitements et transport sont hors
// engagement.
// ============================================================
import Badge from '../../ui/Badge.jsx';
import { formatEuro, formatNumber } from '../../lib/format.js';

export function BilanCommande({ bilan }) {
  if (!bilan) {
    return (
      <p className="field__hint">
        Bilan en euros : il faut au moins un temps réel pour le calculer.
      </p>
    );
  }
  const gagne = bilan.verdict === 'gagne';
  const signe = bilan.ecart_eur > 0 ? '+' : '';
  return (
    <div className="bilan-commande">
      <div className="row row--between">
        <p className="caps">Bilan de la commande — {bilan.quantite} pièce(s), usinage</p>
        <Badge tone={gagne ? 'ok' : 'danger'}>{gagne ? 'Gagné' : 'Perdu'}</Badge>
      </div>
      <dl className="bilan-commande__chiffres">
        <div><dt>Facturé (devis)</dt><dd className="num">{formatEuro(bilan.facture)}</dd></div>
        <div>
          <dt>Il aurait fallu facturer</dt>
          <dd className="num">{formatEuro(bilan.aurait_fallu)}</dd>
        </div>
        <div>
          <dt>Écart</dt>
          <dd className="num">
            {signe}{formatEuro(bilan.ecart_eur)}
            {bilan.ecart_pct != null ? ` (${signe}${formatNumber(bilan.ecart_pct)} %)` : ''}
          </dd>
        </div>
      </dl>
      <p className="field__hint">
        Temps réels × {formatNumber(bilan.taux_machine)} €/h × quantité, mise en route comprise — la même
        formule que le devis.
        {bilan.lignes_sans_reel
          ? ` ${bilan.lignes_sans_reel} ligne(s) sans temps réel sont comptées au temps devisé.`
          : ''}
      </p>
    </div>
  );
}

export default BilanCommande;
